import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Root from './routes/root';
import ErrorPage from './Components/ErrorPage/ErrorPage';
import Progetti from './Components/Progetti/Progetti';
import Credenziali from './Components/Credenziali/Credenziali';
import TestDiCarico from './Components/TestDiCarico/TestDiCarico';
import ProgettiHistory from './Components/ProgettiHisory/ProgettiHistory';
import Dashboard from './Components/Dashboard/Dashboard';
import Iterazioni from './Components/Iterazioni/Iterazioni.js';
import DashboardIterazioni from './Components/Iterazioni/DashboardIterazioni.js';
import store from './store/store.js';
import { Provider } from 'react-redux';
import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";

const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Progetti />,
      },
      {
        path: "progetti",
        element: <Progetti />,
      },
      {
        path: "credenziali",
        element: <Credenziali />,
      },
      {
        path: "carico",
        element: <TestDiCarico />,
      },
      {
        path: "progetti-history",
        element: <ProgettiHistory />,
      },
      {
        path: "dashboard",
        element: <Dashboard />,
      },
      {
        path: "iterazioni",
        element: <Iterazioni />
      },
      {
        path: "dashboardIterazioni",
        element: <DashboardIterazioni />
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
    <RouterProvider router={router} />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
